import { Typography, Box } from "@mui/material";

const HeroBanner = () => {
  return (
    <Box sx={{ mt: "4rem" }}>
      <Typography variant="h2" component="h1" sx={{ fontWeight: "bold" }}>
        100Pods.
      </Typography>
      <Typography variant="h6" sx={{ mt: "1rem" }}>
        Find your 100Pod. Apply today to get connected and supported by 100
        founders in your niche.
      </Typography>
    </Box>
  );
};

export default HeroBanner;
